
import {
  computed,
  defineComponent, onMounted, Ref, ref,
} from 'vue';
import { useRouter } from 'vue-router';
import { useMainStore } from '@/store/mainStore';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import AppLabel from '@/components/AppLabel.vue';
import AppLabelInput from '@/components/UI/AppLabelInput.vue';
import DriveSharedBar from '@/modules/drive/components/DriveSharedBar.vue';
import ItemCase from '@/modules/drive/components/items/ItemCase.vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { BOTTOM_POPUP_TYPES, PHOTO_VIEW_TYPE } from '@/types/enums';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';

export default defineComponent({
  components: {
    AppBottomPopUp,
    AppLabel,
    AppLabelInput,
    ItemCase,
    DriveSharedBar,
  },
  setup() {
    const router = useRouter();
    const mainStore = useMainStore();
    const driveStore = useDriveStore();

    const isEditLabels: Ref<boolean> = ref(false);

    const isPhoto = computed(() => mainStore.BottomPopUpType === BOTTOM_POPUP_TYPES.PHOTO_INFO_OLD);
    const mediaResolver = computed(() => (isPhoto.value ? driveStore.fullscreenPhoto! : driveStore.fullscreenFile!));

    const cases = computed(() => (mediaResolver.value?.whereUsed) || []);
    const isShared = computed(() => mediaResolver.value.ownerId.internalId !== mainStore.user.accountId);

    const sharedTo = computed(() => {
      if (mediaResolver.value?.share) {
        return mediaResolver.value?.share.sharedAccounts.length + mediaResolver.value?.share.sharedGroups.length;
      }
      return false;
    });

    function hidePopUp() {
      mainStore.BottomPopUpType = null;
    }

    function formatDate(date: number): string {
      return new Date(date).toLocaleDateString('en-US', {
        month: 'long', day: '2-digit', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric',
      });
    }

    const fileOwner = computed(() => mediaResolver.value.owner);

    const authorPhotoUrl = computed(() => {
      if (mediaResolver.value.owner.photo?.url) {
        return lowResUrlByViewTypeByUrl(mediaResolver.value.owner.photo?.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    });

    const createdDate = computed(() => formatDate(mediaResolver.value.creationDate));
    const sharedDate = computed(() => {
      if (mediaResolver.value?.sharedTime) {
        return formatDate(mediaResolver.value?.sharedTime);
      }
      return '';
    });
    const updatedDate = computed(() => ' no info');

    function addLabels() {
      if (isEditLabels.value) {
        driveStore.saveFileLabels(isPhoto.value);
      }
      isEditLabels.value = !isEditLabels.value;
    }

    function goToCase(caseId: string) {
      router.push(`/drive/case/my/${caseId}/view/`).then(() => {
        driveStore.fullscreenFile = undefined;
        driveStore.fullscreenPhoto = undefined;
        mainStore.BottomPopUpType = null;
      });
    }

    onMounted(() => {
      mainStore.lablesToTagsInput(mediaResolver.value.labels, true);
    });

    return {
      mainStore,
      sharedTo,
      isEditLabels,
      isPhoto,
      isShared,
      createdDate,
      updatedDate,
      sharedDate,
      fileOwner,
      authorPhotoUrl,
      cases,
      hidePopUp,
      formatDate,
      addLabels,
      goToCase,
    };
  },
});
